import React from 'react';
import { colors } from '@styleseat/brand';

type ReactionsHappyIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ReactionsHappyIcon = ({
  width = 16,
  height = 16,
  color = colors.blackInBlack,
}: ReactionsHappyIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M7.99996 15.3333C3.94987 15.3333 0.666626 12.05 0.666626 7.99996C0.666626 3.94987 3.94987 0.666626 7.99996 0.666626C12.05 0.666626 15.3333 3.94987 15.3333 7.99996C15.3333 12.05 12.05 15.3333 7.99996 15.3333ZM7.99996 14C11.3137 14 14 11.3137 14 7.99996C14 4.68625 11.3137 1.99996 7.99996 1.99996C4.68625 1.99996 1.99996 4.68625 1.99996 7.99996C1.99996 11.3137 4.68625 14 7.99996 14ZM11.2737 10.2989L10.1831 9.53185C9.68616 10.2384 8.87963 10.6666 7.99996 10.6666C7.12029 10.6666 6.31376 10.2384 5.81686 9.53185L4.72625 10.2989C5.47026 11.3567 6.68159 12 7.99996 12C9.31833 12 10.5297 11.3567 11.2737 10.2989ZM9.33329 7.33329V5.99996H10.6666V7.33329H9.33329ZM5.33329 5.99996V7.33329H6.66663V5.99996H5.33329Z" fill={color} />
  </svg>
);
